// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flipbook-container {
  margin: 1rem 0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #fff;
}

.flipbook-container .PDFFlip {
  width: 100% !important;
  height: 100% !important;
  min-height: 400px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .flipbook-container {
    margin: 0.5rem 0;
    border-radius: 5px;
  }

  .flipbook-container .PDFFlip {
    min-height: 300px;
  }
}

/* Loading state */
.flipbook-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  background-color: #f8f9fa;
  border-radius: 10px;
  border: 1px solid #dee2e6;
}

.flipbook-loading .spinner-border {
  width: 3rem;
  height: 3rem;
}

/* Error state */
.flipbook-error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  background-color: #f8f9fa;
  border-radius: 10px;
  border: 1px solid #dee2e6;
  color: #6c757d;
  text-align: center;
  padding: 2rem;
}

.flipbook-error h5 {
  margin-bottom: 1rem;
  color: #dc3545;
}

.flipbook-error p {
  margin-bottom: 0;
  font-size: 0.9rem;
}

/* Override PDF-Flip styles for better integration */
.flipbook-container .PDFFlip .df-ui-btn {
  background-color: #007bff !important;
  border-color: #007bff !important;
}

.flipbook-container .PDFFlip .df-ui-btn:hover {
  background-color: #0056b3 !important;
  border-color: #0056b3 !important;
}

.flipbook-container .PDFFlip .df-ui-controls {
  background: rgba(0, 0, 0, 0.8) !important;
  border-radius: 5px !important;
}

/* Newsletter selection styles */
.newsletter-selector {
  margin-bottom: 1rem;
}

.newsletter-buttons-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 400px;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid rgb(198, 198, 198);
  border-radius: 5px;
}

.newsletter-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 5rem;
  padding: 10px 20px;
  margin: 0;
  border: none;
  border-radius: 12px;
  background-color: rgb(255, 255, 255);
  font-family: inherit;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.newsletter-button:hover {
  background-color: #f8f9fa;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.newsletter-button.active {
  background-color: #007bff;
  color: white;
}

.newsletter-button.active:hover {
  background-color: #0056b3;
}

.newsletter-button-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 1;
}

.newsletter-button-text label {
  color: #1a1919;
  text-decoration: none;
  cursor: pointer;
  margin: 0;
  font-weight: 500;
  text-align: left;
}

.newsletter-button.active .newsletter-button-text label {
  color: white;
}

/* Title display */
.flipbook-title {
  margin-bottom: 1rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
}

.flipbook-title h3 {
  margin: 0;
  color: #333;
  font-size: 1.25rem;
  font-weight: 600;
  text-align: center;
}

/* Responsive styles */
@media (max-width: 576px) {
  .newsletter-button-text label {
    flex-wrap: wrap;
    padding: 5px;
    font-size: 0.9rem;
  }

  .newsletter-button {
    height: auto;
    min-height: 4rem;
    padding: 15px;
  }

  .flipbook-title h3 {
    font-size: 1.1rem;
  }
}

/* Scrollbar styles for newsletter selector */
.newsletter-buttons-container::-webkit-scrollbar {
  width: 0.5rem;
  height: fit-content;
}

.newsletter-buttons-container::-webkit-scrollbar-thumb {
  background-color: rgb(163, 161, 161);
  border-radius: 40px;
}

.newsletter-buttons-container::-webkit-scrollbar-track-piece {
  height: 8px;
}`, "",{"version":3,"sources":["webpack://./src/sass/layout/flipbook/flipbook.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,oDAAoD;AACpD;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".flipbook-container {\n  margin: 1rem 0;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  background-color: #fff;\n}\n\n.flipbook-container .PDFFlip {\n  width: 100% !important;\n  height: 100% !important;\n  min-height: 400px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .flipbook-container {\n    margin: 0.5rem 0;\n    border-radius: 5px;\n  }\n\n  .flipbook-container .PDFFlip {\n    min-height: 300px;\n  }\n}\n\n/* Loading state */\n.flipbook-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  background-color: #f8f9fa;\n  border-radius: 10px;\n  border: 1px solid #dee2e6;\n}\n\n.flipbook-loading .spinner-border {\n  width: 3rem;\n  height: 3rem;\n}\n\n/* Error state */\n.flipbook-error {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  background-color: #f8f9fa;\n  border-radius: 10px;\n  border: 1px solid #dee2e6;\n  color: #6c757d;\n  text-align: center;\n  padding: 2rem;\n}\n\n.flipbook-error h5 {\n  margin-bottom: 1rem;\n  color: #dc3545;\n}\n\n.flipbook-error p {\n  margin-bottom: 0;\n  font-size: 0.9rem;\n}\n\n/* Override PDF-Flip styles for better integration */\n.flipbook-container .PDFFlip .df-ui-btn {\n  background-color: #007bff !important;\n  border-color: #007bff !important;\n}\n\n.flipbook-container .PDFFlip .df-ui-btn:hover {\n  background-color: #0056b3 !important;\n  border-color: #0056b3 !important;\n}\n\n.flipbook-container .PDFFlip .df-ui-controls {\n  background: rgba(0, 0, 0, 0.8) !important;\n  border-radius: 5px !important;\n}\n\n/* Newsletter selection styles */\n.newsletter-selector {\n  margin-bottom: 1rem;\n}\n\n.newsletter-buttons-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 400px;\n  overflow-y: auto;\n  padding: 10px;\n  border: 1px solid rgb(198, 198, 198);\n  border-radius: 5px;\n}\n\n.newsletter-button {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 5rem;\n  padding: 10px 20px;\n  margin: 0;\n  border: none;\n  border-radius: 12px;\n  background-color: rgb(255, 255, 255);\n  font-family: inherit;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.newsletter-button:hover {\n  background-color: #f8f9fa;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.newsletter-button.active {\n  background-color: #007bff;\n  color: white;\n}\n\n.newsletter-button.active:hover {\n  background-color: #0056b3;\n}\n\n.newsletter-button-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  flex: 1;\n}\n\n.newsletter-button-text label {\n  color: #1a1919;\n  text-decoration: none;\n  cursor: pointer;\n  margin: 0;\n  font-weight: 500;\n  text-align: left;\n}\n\n.newsletter-button.active .newsletter-button-text label {\n  color: white;\n}\n\n/* Title display */\n.flipbook-title {\n  margin-bottom: 1rem;\n  padding: 1rem;\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n}\n\n.flipbook-title h3 {\n  margin: 0;\n  color: #333;\n  font-size: 1.25rem;\n  font-weight: 600;\n  text-align: center;\n}\n\n/* Responsive styles */\n@media (max-width: 576px) {\n  .newsletter-button-text label {\n    flex-wrap: wrap;\n    padding: 5px;\n    font-size: 0.9rem;\n  }\n\n  .newsletter-button {\n    height: auto;\n    min-height: 4rem;\n    padding: 15px;\n  }\n\n  .flipbook-title h3 {\n    font-size: 1.1rem;\n  }\n}\n\n/* Scrollbar styles for newsletter selector */\n.newsletter-buttons-container::-webkit-scrollbar {\n  width: 0.5rem;\n  height: fit-content;\n}\n\n.newsletter-buttons-container::-webkit-scrollbar-thumb {\n  background-color: rgb(163, 161, 161);\n  border-radius: 40px;\n}\n\n.newsletter-buttons-container::-webkit-scrollbar-track-piece {\n  height: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
